import React, { useState } from "react";
import clsx from "clsx";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@material-ui/core";
import { CustomIconButton } from "../../../Components";

import useStyles from "./styles";

import { ChevronDown } from "../../../assets/icons";

export default function CustomExpandCard({ CardSummary, CardExpandContent, expandedRootClassName, summaryRootClassName }) {
  const styles = useStyles();
  const [showHighlight, setShowHighlight] = useState(false);
  const [expand, setExpand] = useState(false);

  return (
    <Box
      className={clsx(styles.accordion, { [styles.highlight]: showHighlight })}
    >
      <Accordion
        onChange={(_, expanded) => {
          setShowHighlight(expanded);
          setExpand(expanded);
        }}
        TransitionProps={{ unmountOnExit: true }}
      >
        <AccordionSummary
          expandIcon={<ChevronDown />}
          className={clsx(styles.cardContainer,{[summaryRootClassName]: !!summaryRootClassName})}
        >
          {CardSummary ?? null}
          <CustomIconButton
            variant="text"
            size="xs"
            hideHoverBg
            boxShadow="none"
          >
            <Typography className={styles.expandText}>View Details</Typography>
            <ChevronDown
              className={clsx(styles.icon, {
                [styles.iconActive]: expand,
              })}
            />
          </CustomIconButton>
        </AccordionSummary>
        <AccordionDetails className={clsx(styles.cardContainer, { [expandedRootClassName]: !!expandedRootClassName })}>
          {CardExpandContent ? CardExpandContent(expand) : null}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
